import React, { useState } from 'react';
import Header from '../../../../../Header/Header';
import Navigationbar from '../../../../../Navigationbar/Navigationbar';
import CSCEAgent from './CSCEAgent';
import CSCESelfServe from './CSCESelfServe';

/**
 * Used to show the action item on the nav bar and when user clicks on 
 * that it will take the user to the particular component.
 * Toggle between Normal (agent) mode and Self Serve mode.
 * @param {*} props 
 * @returns 
 */
const CSCEAgentWrapper = (props) => {

    const { themeSelected } = props;
    const [isSelfServe, setIsSelfServe] = useState(false);

    return (
        <div className='container-fluid m-1' style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <Header {...props} />
            <Navigationbar {...props} />

            {/* Toggle Bar */}
            <div className='d-flex align-items-center mt-2 mb-1' style={{ gap: '12px' }}>
                <span style={{ fontWeight: 500, fontSize: '14px' }}>Mode:</span>
                <div
                    className='d-flex align-items-center'
                    style={{
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        userSelect: 'none',
                    }}
                >
                    <button
                        onClick={() => setIsSelfServe(false)}
                        style={{
                            padding: '6px 18px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: isSelfServe ? 400 : 600,
                            background: isSelfServe ? '#f5f5f5' : '#106D96',
                            color: isSelfServe ? '#555' : '#fff',
                            transition: 'all 0.2s',
                            fontSize: '13px',
                        }}
                    >
                        Normal
                    </button>
                    <button
                        onClick={() => setIsSelfServe(true)}
                        style={{
                            padding: '6px 18px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: isSelfServe ? 600 : 400,
                            background: isSelfServe ? '#106D96' : '#f5f5f5',
                            color: isSelfServe ? '#fff' : '#555',
                            transition: 'all 0.2s',
                            fontSize: '13px',
                        }}
                    >
                        Self Serve
                    </button>
                </div>
            </div>

            {/* Content */}
            {isSelfServe
                ? <CSCESelfServe style={{ flex: '1' }} themeSelected={themeSelected} />
                : <CSCEAgent className='mt-3' style={{ flex: '1' }} themeSelected={themeSelected} />
            }
        </div>
    );
};

export default CSCEAgentWrapper;
